import gql from 'graphql-tag';

import type {
  NormalizedInProgressCourse,
  NormalizedNotStartedCourse,
  NormalizedPassedCourse,
} from '../types/courseStates';

export const getDegreeLearnerCourseStates = gql`
  query GetDegreeLearnerCourseStatesQuery($degreeId: ID!) {
    DegreeHome {
      degreeLearnerCourseStatesByUserIdAndDegreeId(degreeId: $degreeId) {
        id
        notStarted {
          course {
            id
            name
            slug
          }
          activeSessionId
          hasEnrollableSession
        }
        passed {
          course {
            id
            name
            slug
          }
        }
        inProgress {
          course {
            id
            name
            slug
          }
          activeSessionId
          hasEnrollableSession
        }
      }
    }
  }
`;

type NewNotStartedCourseState = {
  course: { id: string; name: string; slug: string };
  activeSessionId: string | null;
  hasEnrollableSession: boolean;
};

type NewPassedCourseState = {
  course: { id: string; name: string; slug: string };
};

type NewInProgressCourseState = {
  course: { id: string; name: string; slug: string };
  activeSessionId: string;
  hasEnrollableSession: boolean;
};

export function mapNewNotStartedCourses(courses: NewNotStartedCourseState[]): NormalizedNotStartedCourse[] {
  return courses.map((state) => ({
    id: state.course.id,
    name: state.course.name,
    slug: state.course.slug,
    activeSessionId: state.activeSessionId,
    hasEnrollableSession: state.hasEnrollableSession,
  }));
}

export function mapNewPassedCourses(courses: NewPassedCourseState[]): NormalizedPassedCourse[] {
  return courses.map((state) => ({
    id: state.course.id,
    name: state.course.name,
    slug: state.course.slug,
  }));
}

export function mapNewInProgressCourses(courses: NewInProgressCourseState[]): NormalizedInProgressCourse[] {
  return courses.map((state) => ({
    id: state.course.id,
    name: state.course.name,
    slug: state.course.slug,
    activeSessionId: state.activeSessionId,
    hasEnrollableSession: state.hasEnrollableSession,
  }));
}
